var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"100%","height":"auto","display":"block"},attrs:{"src":_vm.agreement,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }